export class MonitorStatus {
  private static readonly options = new Map([
    [1, "Aberta"],
    [2, "Pendente"],
    [3, "Concluída"],
    [4, "Cancelada"],
    [5, "Expirada"],
    [6, "Excedida"], //Foi mantido este, caso em algum ambiente esteja como 6
    [7, "Devolvida"],
    [8, "Devolução"], //Agora "Restrição" está chegando como 7 do backend
    [99, "Restrição"],
  ]);

  public static fromEnum(value: number): MonitorStatus {
    return new MonitorStatus(value);
  }

  private readonly description: string;

  private constructor(status: number) {
    const textStatus = MonitorStatus.options.get(status);
    if (textStatus) {
      this.description = textStatus;
    } else {
      this.description = status + "";
    }
  }

  public getDescription(): string {
    return this.description;
  }
}
